export const whatsAppTextContactUs = ''
export const BRIO_SAC_WHATSAPP_NUMBER = '55113003-4536'
export const WHATSAPP_WEB_URL = 'https://api.whatsapp.com/send?phone=551130034536'
